import React, { Component } from "react";
import lang from "../../lang";
import channelConfig from '../../component/recharge/config';
import secondChannel from '../../component/recharge/second-config'
import PayEntryH5WebPay from '../../component/recharge/index';
import iframePopup from '../../lib/popup/iframe';
import VipView from './vip';
import APP from '../../im/index'
import url from 'c-url';


class RechargeView extends Component {
    constructor(props) {
        super(props);
        let countryCode = url.query('adscountry') || UP.Global.getUser().countryCode;
        let channelList;
        let subList;
        let pepaySubList;

        this.countryCode = countryCode = (countryCode != 'PK' && UP.Global.middelEastCountryCodes.indexOf(countryCode) > -1) ? 'MSL' : countryCode;

        switch (countryCode) {
            case 'CN': // 大陆地区
                channelList = ['vipcz', 'wxpay', 'alipay'];
                break;

            case 'MSL': // 中东地区
                channelList = ['vipcz', 'paypal', 'onecard'];
                break;
            case 'PK': // 巴基斯坦地区
                channelList = ['vipcz', 'paypal', 'onecard'];
                break;

            case 'MY':
                channelList = ['vipcz','dokypay', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'ID': // 印尼
                channelList = ['vipcz', 'codapay', 'pepay'];
                subList = secondChannel.codapayId;
                pepaySubList = secondChannel.pepay;
                break;
            case 'US':
                channelList = ['vipcz', 'paypal'];
                break;
            case 'VN':
                channelList = ['vipcz', 'paypal'];
                break;
            case 'TH':
                channelList = ['pepay_entitycard_thb', 'paypal', 'vipcz', 'wxpay', 'alipay'];
                break;
            case 'KR':
                channelList = ['vipcz', 'kakaopay', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'IN': // 印度
                // channelList = ['vipcz', 'paypal', 'codapay_390', 'codapay_391']
                channelList = ['vipcz','paypal','dokypay'];
                break;
            case 'PH': // 菲律宾
                channelList = ['vipcz', 'codapay'];
                subList = secondChannel.codapayPh
                break;
            case 'TW': // 台湾
                channelList = ['vipcz','pepay_credit', 'pepay_store', 'sinopac_atm', 'bj_mycard', 'gash', 'gash_card', 'paypal'];
                pepaySubList = secondChannel.pepay_store;
                break;
            case 'HK': // 香港
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'JP': // 日本
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
                break;
            default:
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
        }

        // IE 下去掉支付宝充值方式

        if (UP.Global.isIE && channelList.indexOf('alipay') > -1) {
            channelList.splice(channelList.indexOf('alipay'), 1);
        }


        let rendered = [];

        for (let i = channelList.length; i--;) {
            if (i == 0) {
                rendered[i] = 1;
            } else {
                rendered[i] = 0;
            }
        }

        this.state = {
            channelList: channelList,
            rendered: rendered, // 存储支付panel渲染的状态。panel若已render，则做隐藏操作
            selectedOption: channelList[0],
            subList: subList,
            codapayChannel: subList != undefined ? subList[0] : '',
            codapayvalue: '',
            pepaySubList: pepaySubList,
            pepayChannel: pepaySubList != undefined ? pepaySubList[0] : '',
            pepayvalue: '',
        };


        this.showExceptionPopupMap = {};
    }

    componentDidMount() {
        let channel = sessionStorage.getItem('channel')
        let codapayoption;

        $.channel.on('getOptionListError', () => {
            this.showExceptionPopup();
        });

        //home页点击充值页面后选中支付方式
        if (channel != null) {
            if (this.state.subList != undefined) {
                codapayoption = this.state.subList[0];
            } else if (this.state.pepaySubList != undefined) {
                codapayoption = this.state.pepaySubList[0];
            } else {

                codapayoption = '';
            }
            this.onTabClick(channel, codapayoption);
            sessionStorage.removeItem('channel');
        } else {

            if (['CN'].indexOf(this.countryCode) > -1) {
                this.onTabClick(this.state.channelList[1]);
            }
        }
    }

    showExceptionPopup() {
        let self = this;

        iframePopup.create({
            url: 'https://m.upliveapps.com/ipay/exception.html?lang=' + UP.Global.siteLanguage,
            onHide: function() {
                if (self.state.selectedOption == 'codapay') {
                    self.showExceptionPopupMap[self.state.codapayChannel] = 1;
                } else {
                    self.showExceptionPopupMap[self.state.selectedOption] = 1;
                }

                self.setState({
                    selectedOption: self.state.channelList[0] // 关闭弹出框，回到VIP充值
                });
            }
        });
    }

    componentWillUnmount() {
        $.channel.off('getOptionListError');
    }


    onTabClick = (option, codapayoption, pepayoption) => {
        
        if (option == 'codapay') {
            this.setState({
                codapayvalue: 'codapay',
                codapayChannel: codapayoption
            })

        } else if (option == 'pepay') {
            this.setState({
                pepayvalue: 'pepay',
                pepayChannel: pepayoption
            })
        } else if (option == 'pepay_store') {
            this.setState({
                pepayvalue: 'pepay_store',
                pepayChannel: pepayoption
            })
        } else {

            if (this.state.selectedOption == option) {
                return;
            }
        }

        let index = this.state.channelList.indexOf(option);
        let rendered = this.state.rendered;

        rendered[index] = 1;

        this.setState({
            rendered: rendered,
            selectedOption: option,
            codapayChannel: codapayoption,
            pepayChannel: pepayoption
        }, function() {
            if (this.showExceptionPopupMap[option]) {
                this.showExceptionPopup();
            }
        });
    }

    callService = () => {
        $.channel.emit('showChat');
    }

    render() {
        let userInfo = UP.Global.getUser();
        let countryCode = this.countryCode;
        let { selectedOption, channelList, codapayChannel, subList, codapayvalue, pepayChannel, pepaySubList, pepayvalue } = this.state;
        let $channelList = [];
        let $contentList = [];
        let $codapay_id = [];
        let $pepay_id = []

        $.map(channelList, (value, index) => {

            let item = channelConfig[value];
            if (item.open) {
                // 处理tab
                let text;

                switch (value) {
                    case 'bj_mycard':
                        text = lang.template('mycard');
                        break;
                    case 'paypal':
                        text = lang.template('paypal');
                        break;
                    case 'onecard':
                        text = lang.template('onecard');
                        break;
                    case 'alipay':
                        text = lang.template('支付宝');
                        break;
                    case 'wxpay':
                        text = lang.template('微信支付');
                        break;
                    case 'codapay':
                        text = lang.template('codapay');
                        break;
                    case 'molpay_points':
                        text = lang.template('molpay_points');
                        break;
                    case 'pepay_entitycard_thb':
                        text = 'CashCard(THB)';
                        break;
                    case 'pepay_entitycard_vnd':
                        text = lang.template('pepay_entitycard_vnd');
                        break;
                    case 'pepay_onlinebank_vnd':
                        text = lang.template('pepay_onlinebank_vnd');
                        break;
                    case 'bk_atm':
                        text = lang.template('ATM/Credit Card');
                        break;
                    case 'pepay_alfamart_idr':
                        text = 'Alfamart';
                        break;
                    case 'pepay_webatm_idr':
                        text = 'Bank Atm';
                        break;
                    case 'sinopac_atm':
                        text = 'Bank(Taiwan)';
                        break;
                    case 'kakaopay':
                        text = lang.template('kakaopay');
                        break;
                    case 'pepay_credit':
                        text = lang.template('信用卡專區');
                        break;
                     case 'pepay_store':
                        text = lang.template('便利超商代收');
                        break;
                    case 'vip':
                    case 'vipcz':
                        text = lang.template('VIP充值');
                        break;
                    case 'pepay':
                        text = lang.template('PePay');
                        break;
                    case 'codapay_390':
                        text = lang.template('Paytm Wallet');
                        break;
                    case 'codapay_391':
                        text = lang.template('Bank Transfer');
                        break;
                    default:
                        text = item.text;
                }

                let node = (
                    <li  key={index}>
                        <div className={item.option == selectedOption ? 'selected channel-item' : 'channel-item'}
                             onClick={this.onTabClick.bind(this, item.option, subList != undefined ? subList[0] : '',pepaySubList != undefined ? pepaySubList[0] : '')}>
                            {item.option == 'sinopac_atm' || item.option == 'pepay_entitycard_thb' ?
                                <span>{text}&lrm;</span> : <span>{text}</span>}
                        </div>
                        {
                            value == 'vipcz' && lang.template('VIP优惠描述') !== 'VIP优惠描述' && ['CN', 'TW', 'MO', 'MYC', 'HK'].indexOf(countryCode) > -1 ?
                            <div className="floatip"
                                 dangerouslySetInnerHTML={{__html: lang.template('VIP优惠描述')}}></div> : null}
                        {
                            (item.option == 'codapay' && selectedOption == 'codapay' && subList != undefined) ?
                            <div className='pay-box'>
                                <ul className="channel-list channel-pay">
                                    {$codapay_id}
                                </ul>
                            </div>
                            : null
                        }
                        {
                            (item.option == 'pepay' && selectedOption == 'pepay' && pepaySubList != undefined) ?
                            <div className='pay-box pepay-box'>
                                <ul className="channel-list channel-pay">
                                {$pepay_id}
                                </ul>
                                </div>
                            : null
                        }
                        {
                            (item.option == 'pepay_store' && selectedOption == 'pepay_store' && pepaySubList != undefined) ?
                            <div className='pay-box pepaystore-box'>
                                <ul className="channel-list channel-pay">
                                {$pepay_id}
                                </ul>
                                </div>
                            : null
                        }
                    </li>
                )

                $channelList[$channelList.length] = node;


                // 处理Tab对应的内容
                let $content;

                if (this.state.rendered[index]) {
                    let $entry;

                    if (value == 'vipcz') {
                        $entry = <VipView/>;
                    } else if (value == 'codapay') {
                        $entry = <PayEntryH5WebPay uid={userInfo.uid} channel={this.state.codapayChannel}/>
                    } else if (value == 'pepay' || value == 'pepay_store') {
                        $entry = <PayEntryH5WebPay uid={userInfo.uid} channel={this.state.pepayChannel}/>
                    } else {
                        $entry = <PayEntryH5WebPay uid={userInfo.uid} channel={value}/>
                    }

                    $content = <div key={value} className={value == selectedOption ? '' : 'hidden'}>{$entry}</div>;
                } else {
                    $content = <div key={value} className="hidden"></div>;
                }

                $contentList[$contentList.length] = $content;
            }
        });

        //印尼、菲律宾codapay新增支付方式
        if (subList != undefined) {
            $.map(this.state.subList, (value, index) => {

                let item = channelConfig[value];
                if (item.open) {

                    let codapayList = (
                        <li  key={index}>
                            <div className={item.option == codapayChannel ? 'channel-item selected' : 'channel-item'}
                                 onClick={this.onTabClick.bind(this, codapayvalue, item.option,item.option)}>
                                {<span>{item.text}</span>}
                            </div>
                        </li>
                    )
                    $codapay_id[$codapay_id.length] = codapayList;

                }

            })

        };
        if (pepaySubList != undefined) {

            $.map(this.state.pepaySubList, (value, index) => {

                let item = channelConfig[value];
                if (item.open) {

                    let pepayList = (
                        <li  key={index} data-type={item.option}>
                        <div className={item.option == pepayChannel ? 'channel-item selected' : 'channel-item'}
                    onClick={this.onTabClick.bind(this, pepayvalue, item.option,item.option)}>
                    {<span>{item.text}</span>}
                    </div>
                    </li>
                    )
                    $pepay_id[$pepay_id.length] = pepayList;

                }

            })
        }

        return (
            <div>
                <h3 className="titles">{lang.template('充值方式')}  </h3>
                <ul className="channel-list clearfix" data-current={selectedOption}>
                    {$channelList}
                </ul>

                {
                    selectedOption == 'bj_mycard' && lang.template('mycard充值提示') !== 'mycard充值提示' ?
                    <div className="mycard-tip">{lang.template('mycard充值提示')}</div> : null
                }
                {
                   ['vip', 'vipcz', 'pepay_entitycard_thb', 'pepay_entitycard_vnd', 'icard', 'gash_card'].indexOf(selectedOption) == -1 ? 
                    <h3 className="titles">{lang.template('充值数量')}</h3> : null
                }
                {$contentList}
                <div className="kefu">
                    <span>{lang.template('充值遇到问题,点此')}</span>
                    <em className='kefu-click' onClick={this.callService}>
                        {lang.template('联系客服')}
                        </em>
                </div>

            </div>
        );
    }
}

export default RechargeView;


// WEBPACK FOOTER //
// ./js/mall/recharge/h5.js